export default {
  GET_CATEGORY_LIST: state => {
    return state.category;
  }, 
};
